export const DashboardMenu = {
  labelLogout: 'Sair',
  labelOrders: 'Pedidos em Curso',
  labelAvailableOrders: 'Pedidos Disponíveis',
  labelDispatchOrders: 'Pedidos Expedidos',
  labelAdmin: 'Administração'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardMenu.js